import React from 'react';
import { Routes, Route } from 'react-router-dom';

import CustomRoute from './Route';

import SignIn from '../pages/SignIn';
import Questions from '../pages/Questions/index';
import QuestionTranslations from '../pages/Questions/Translations';
import ImportFile from '../pages/Questions/ImportFile';
import ImportSample from '../pages/Accesses/ImportSample';
import CreateQuestion from '../pages/Questions/New';
import EditQuestion from '../pages/Questions/Edit';
import LanguageSettings from '../pages/LanguageSettings';
import Surveys from '../pages/Surveys';
import CreateSurvey from '../pages/Surveys/New';
import EditSurvey from '../pages/Surveys/Edit';
import Survey from '../pages/Questionnaire';
import MoreInfo from '../pages/Questionnaire/Start/InfoText/index';
import Products from '../pages/Products';
import SurveyTemplate from '../pages/Products/SurveyTemplate';
import SurveyTemplateDemo from '../pages/Products/SurveyTemplate/Demo';
import CreateProduct from '../pages/Products/New';
import CreateStructure from '../pages/Products/Structure';
import TemplateDecision from '../pages/Products/TemplateDecision';
import CreateProject from '../pages/Projects/New';
import EditProject from '../pages/Projects/Edit';
import Projects from '../pages/Projects';
import ProjectDashboard from '../pages/Projects/Dashboard';
import ProjectParticipation from '../pages/Projects/Participation';
import ProjectAnalytics from '../pages/Projects/Analytics';
import ProjectOpenAnswers from '../pages/Projects/OpenAnswers';
import Customers from '../pages/Customers';
import Languages from '../pages/Languages';
import CreateCustomer from '../pages/Customers/New';
import EditCustomer from '../pages/Customers/Edit';
import MatrixList from '../pages/MatrixQuestions';
import CreateMatrixStep1 from '../pages/MatrixQuestions/New/Step1';
import CreateMatrixStep2 from '../pages/MatrixQuestions/New/Step2';
import SurveyTexts from '../pages/SurveyTexts';
import CreateSurveyText from '../pages/SurveyTexts/New';
import EditSurveyText from '../pages/SurveyTexts/Edit';
import Logos from '../pages/Logos';
import CreateLogo from '../pages/Logos/New';
import Images from '../pages/Images';
import UploadImages from '../pages/Images/New';
import Accesses from '../pages/Accesses';
import CreateAccess from '../pages/Accesses/New';
import EditAccess from '../pages/Accesses/Edit';
import SearchAccess from '../pages/Accesses/Search';
import ExportResult from '../pages/Surveys/ExportResult';
import OpenAnswers from '../pages/Surveys/OpenAnswers';
import OpenAnswersImportFile from '../pages/Surveys/OpenAnswers/ImportFile';
import ExportResultGeneric from '../pages/ExportResultGeneric';
import Analytics from '../pages/Surveys/Analytics';
import Style from '../pages/Surveys/Style';
import AfterSurvey from '../pages/Questionnaire/AfterSurvey/index';
import Respondents from '../pages/Respondents';
import CreateLanguage from '../pages/Languages/New';
import EditLanguage from '../pages/Languages/Edit';
import SurveyTranslations from '../pages/Surveys/SurveyTranslations';
import EditSurveyTranslations from '../pages/Surveys/SurveyTranslations/Edit';
import CreateSurveyTranslation from '../pages/Surveys/SurveyTranslations/New';
import GDPR from '../pages/GDPR';
import CreateGDPR from '../pages/GDPR/New';
import EditGDPR from '../pages/GDPR/Edit';
import Segments from '../pages/Segments';
import CreateSegment from '../pages/Segments/New';
import Categories from '../pages/Categories';
import CreateCategories from '../pages/Categories/New';
import ExportToPdf from '../pages/Surveys/ExportToPdf';
import ExportQuestionnaireToPdf from '../pages/Questionnaire/ExportToPdf';
import Logs from '../pages/Logs';
import LogsQuestion from '../pages/Logs/Questions';
import LogsAnswers from '../pages/Logs/Answers';
import Participation from '../pages/ParticipationCustomer';
import ParticipationLink from '../pages/ParticipationLink';
import CreateParticipationLink from '../pages/ParticipationLink/New';
import EditParticipationLink from '../pages/ParticipationLink/Edit';
import ExportDataWarehouse from '../pages/Surveys/ExportDataWarehouse';
import RunAnalyser from '../pages/Surveys/RunAnalyser';
import Tags from '../pages/Tags';
import TagTranslations from '../pages/TagTranslations';
import ImportTagTranslations from '../pages/TagTranslations/new';
import CreateTag from '../pages/Tags/New';
import EditTag from '../pages/Tags/Edit';
import AnalyticsPageLinks from '../pages/AnalyticsPage';
import AnalyticsPageNew from '../pages/AnalyticsPage/New';
import AnalyticsPageEdit from '../pages/AnalyticsPage/Edit';
import Apillares from '../pages/Apillares';
import CreateApillar from '../pages/Apillares/New';
import EditApillar from '../pages/Apillares/Edit';
import AccessGroup from '../pages/AccessGroup';
import CreateAccessGroup from '../pages/AccessGroup/New';
import EditAccessGroup from '../pages/AccessGroup/Edit';
import Videos from '../pages/Videos';
import UploadVideos from '../pages/Videos/New';
import SurveyListToExport from '../pages/Surveys/ExportDataWarehouse/SurveyListToExport/index';
import RedirectionOldLinks from '../pages/Questionnaire/RedirectionOldLinks';
import ResetPassword from '../pages/PasswordRecovery';
import MatrixChart from '../pages/Surveys/MatrixChart';
import RecoverySummary from '../pages/RecoverySummary';

const RoutesComponent: React.FC = () => (
  <Routes>
    <Route path="/" element={<CustomRoute element={<SignIn />} />} />

    <Route
      path="/questions"
      element={<CustomRoute element={<Questions />} isPrivate />}
    />
    <Route
      path="/questions/new"
      element={<CustomRoute element={<CreateQuestion />} isPrivate />}
    />
    <Route
      path="/questions/edit/:questionId"
      element={<CustomRoute element={<EditQuestion />} isPrivate />}
    />
    <Route
      path="/questions/translations"
      element={<CustomRoute element={<QuestionTranslations />} isPrivate />}
    />
    <Route
      path="/questions/importFile"
      element={<CustomRoute element={<ImportFile />} isPrivate />}
    />

    <Route
      path="/languageSettings"
      element={<CustomRoute element={<LanguageSettings />} isPrivate />}
    />

    <Route
      path="/surveys"
      element={<CustomRoute element={<Surveys />} isPrivate />}
    />
    <Route
      path="/surveys/project/:projectId"
      element={<CustomRoute element={<Surveys />} isPrivate />}
    />
    <Route
      path="/surveys/new"
      element={<CustomRoute element={<CreateSurvey />} isPrivate />}
    />
    <Route
      path="/surveys/:surveyId"
      element={<CustomRoute element={<EditSurvey />} isPrivate />}
    />
    <Route
      path="/surveys/:surveyId/accesses"
      element={<CustomRoute element={<Accesses />} isPrivate />}
    />
    <Route
      path="/surveys/:surveyId/accesses/new"
      element={<CustomRoute element={<CreateAccess />} isPrivate />}
    />
    <Route
      path="/surveys/:surveyId/accesses/edit/:accessId"
      element={<CustomRoute element={<EditAccess />} isPrivate />}
    />

    <Route
      path="/accesses/search"
      element={<CustomRoute element={<SearchAccess />} isPrivate />}
    />
    <Route
      path="/accesses/importSample"
      element={<CustomRoute element={<ImportSample />} isPrivate />}
    />

    <Route
      path="/surveys/:surveyId/export"
      element={<CustomRoute element={<ExportResult />} isPrivate />}
    />
    <Route
      path="/surveys/:surveyId/answers"
      element={<CustomRoute element={<OpenAnswers />} isPrivate />}
    />

    <Route
      path="/surveys/:surveyId/ChartMatrixes"
      element={<CustomRoute element={<MatrixChart />} isPrivate />}
    />

    <Route
      path="/surveys/:surveyId/answers/importFile"
      element={<CustomRoute element={<OpenAnswersImportFile />} isPrivate />}
    />
    <Route
      path="/surveys/:surveyId/runAnalyser"
      element={<CustomRoute element={<RunAnalyser />} isPrivate />}
    />

    <Route
      path="/ExportResultGeneric"
      element={<CustomRoute element={<ExportResultGeneric />} isPrivate />}
    />
    <Route
      path="/surveys/:surveyId/surveyTranslations"
      element={<CustomRoute element={<SurveyTranslations />} isPrivate />}
    />
    <Route
      path="/surveys/surveyTranslations/new"
      element={<CustomRoute element={<CreateSurveyTranslation />} isPrivate />}
    />
    <Route
      path="/surveys/surveyTranslations/edit/:surveyTranslationId"
      element={<CustomRoute element={<EditSurveyTranslations />} isPrivate />}
    />
    <Route
      path="/surveys/:surveyId/analytics"
      element={<CustomRoute element={<Analytics />} isSurvey />}
    />

    <Route
      path="/style"
      element={<CustomRoute element={<Style />} isSurvey isPrivate />}
    />

    <Route
      path="/projects/:projectId/analytics"
      element={<CustomRoute element={<ProjectAnalytics />} isPrivate />}
    />
    <Route
      path="/projects/:projectId/openAnswers"
      element={<CustomRoute element={<ProjectOpenAnswers />} isPrivate />}
    />

    <Route
      path="/questionnaire/:accessObjectId/:accessId/:code?"
      element={<CustomRoute element={<Survey />} isSurvey />}
    />
    <Route
      path="/questionnaire/:accessId/:code?"
      element={<CustomRoute element={<RedirectionOldLinks />} isSurvey />}
    />

    <Route
      path="/aftersurvey"
      element={<CustomRoute element={<AfterSurvey />} isSurvey />}
    />
    <Route
      path="/moreinfo/"
      element={<CustomRoute element={<MoreInfo />} isSurvey />}
    />

    <Route
      path="/projects/new"
      element={<CustomRoute element={<CreateProject />} isPrivate />}
    />
    <Route
      path="/projects/edit/:projectId"
      element={<CustomRoute element={<EditProject />} isPrivate />}
    />
    <Route
      path="/projects"
      element={<CustomRoute element={<Projects />} isPrivate />}
    />
    <Route
      path="/projects/:projectId/dashboard"
      element={<CustomRoute element={<ProjectDashboard />} isPrivate />}
    />
    <Route
      path="/projects/:projectId/participation"
      element={<CustomRoute element={<ProjectParticipation />} isPrivate />}
    />

    <Route
      path="/products"
      element={<CustomRoute element={<Products />} isPrivate />}
    />
    <Route
      path="/products/surveyTemplate"
      element={<CustomRoute element={<SurveyTemplate />} isPrivate />}
    />
    <Route
      path="/products/surveyTemplate/:surveyId"
      element={<CustomRoute element={<SurveyTemplateDemo />} isSurvey />}
    />
    <Route
      path="/products/templateDecision"
      element={<CustomRoute element={<TemplateDecision />} isPrivate />}
    />
    <Route
      path="/products/new"
      element={<CustomRoute element={<CreateProduct />} isPrivate />}
    />
    <Route
      path="/products/structure"
      element={<CustomRoute element={<CreateStructure />} isPrivate />}
    />
    <Route
      path="/products/structure/:productId"
      element={<CustomRoute element={<CreateStructure />} isPrivate />}
    />

    <Route
      path="/customers"
      element={<CustomRoute element={<Customers />} isPrivate />}
    />
    <Route
      path="/customers/new"
      element={<CustomRoute element={<CreateCustomer />} isPrivate />}
    />
    <Route
      path="/customers/edit/:id"
      element={<CustomRoute element={<EditCustomer />} isPrivate />}
    />

    <Route
      path="/languages"
      element={<CustomRoute element={<Languages />} isPrivate />}
    />
    <Route
      path="/languages/new"
      element={<CustomRoute element={<CreateLanguage />} isPrivate />}
    />
    <Route
      path="/languages/edit/:id"
      element={<CustomRoute element={<EditLanguage />} isPrivate />}
    />

    <Route
      path="/matrixQuestions"
      element={<CustomRoute element={<MatrixList />} isPrivate />}
    />
    <Route
      path="/matrixQuestions/step1"
      element={<CustomRoute element={<CreateMatrixStep1 />} isPrivate />}
    />
    <Route
      path="/matrixQuestions/step2"
      element={<CustomRoute element={<CreateMatrixStep2 />} isPrivate />}
    />
    <Route
      path="/matrixQuestions/step2/:productId"
      element={<CustomRoute element={<CreateMatrixStep2 />} isPrivate />}
    />

    <Route
      path="/surveyTexts"
      element={<CustomRoute element={<SurveyTexts />} isPrivate />}
    />
    <Route
      path="/surveyTexts/type/:textType"
      element={<CustomRoute element={<SurveyTexts />} isPrivate />}
    />
    <Route
      path="/surveyTexts/new"
      element={<CustomRoute element={<CreateSurveyText />} isPrivate />}
    />
    <Route
      path="/surveyTexts/edit/:id"
      element={<CustomRoute element={<EditSurveyText />} isPrivate />}
    />

    <Route
      path="/gdpr"
      element={<CustomRoute element={<GDPR />} isPrivate />}
    />
    <Route
      path="/gdpr/new"
      element={<CustomRoute element={<CreateGDPR />} isPrivate />}
    />
    <Route
      path="/gdpr/edit/:id"
      element={<CustomRoute element={<EditGDPR />} isPrivate />}
    />

    <Route
      path="/segments"
      element={<CustomRoute element={<Segments />} isPrivate />}
    />
    <Route
      path="/segments/new"
      element={<CustomRoute element={<CreateSegment />} isPrivate />}
    />

    <Route
      path="/categories"
      element={<CustomRoute element={<Categories />} isPrivate />}
    />
    <Route
      path="/categories/new"
      element={<CustomRoute element={<CreateCategories />} isPrivate />}
    />

    <Route
      path="/tags"
      element={<CustomRoute element={<Tags />} isPrivate />}
    />
    <Route
      path="/tags/new"
      element={<CustomRoute element={<CreateTag />} isPrivate />}
    />
    <Route
      path="/tags/edit/:tagId"
      element={<CustomRoute element={<EditTag />} isPrivate />}
    />

    <Route
      path="/apillars"
      element={<CustomRoute element={<Apillares />} isPrivate />}
    />
    <Route
      path="/apillars/new"
      element={<CustomRoute element={<CreateApillar />} isPrivate />}
    />
    <Route
      path="/apillars/edit/:id"
      element={<CustomRoute element={<EditApillar />} isPrivate />}
    />

    <Route
      path="/accessGroup"
      element={<CustomRoute element={<AccessGroup />} isPrivate />}
    />
    <Route
      path="/accessGroup/new"
      element={<CustomRoute element={<CreateAccessGroup />} isPrivate />}
    />
    <Route
      path="/accessGroup/edit/:id"
      element={<CustomRoute element={<EditAccessGroup />} isPrivate />}
    />

    <Route
      path="/tagTranslations"
      element={<CustomRoute element={<TagTranslations />} isPrivate />}
    />
    <Route
      path="/tagTranslations/new"
      element={<CustomRoute element={<ImportTagTranslations />} isPrivate />}
    />

    <Route
      path="/logos"
      element={<CustomRoute element={<Logos />} isPrivate />}
    />
    <Route
      path="/logos/new"
      element={<CustomRoute element={<CreateLogo />} isPrivate />}
    />

    <Route
      path="/Images"
      element={<CustomRoute element={<Images />} isPrivate />}
    />
    <Route
      path="/Images/new"
      element={<CustomRoute element={<UploadImages />} isPrivate />}
    />

    <Route
      path="/Videos"
      element={<CustomRoute element={<Videos />} isPrivate />}
    />
    <Route
      path="/Videos/new"
      element={<CustomRoute element={<UploadVideos />} isPrivate />}
    />

    <Route
      path="/respondents"
      element={<CustomRoute element={<Respondents />} isPrivate />}
    />

    <Route
      path="/exportToPdf"
      element={<CustomRoute element={<ExportToPdf />} isSurvey />}
    />
    <Route
      path="/exportQuestionnaireToPdf/:accessId"
      element={<CustomRoute element={<ExportQuestionnaireToPdf />} isSurvey />}
    />

    <Route
      path="/Logs"
      element={<CustomRoute element={<Logs />} isPrivate />}
    />
    <Route
      path="/Logs/Questions"
      element={<CustomRoute element={<LogsQuestion />} isPrivate />}
    />
    <Route
      path="/Logs/Answers"
      element={<CustomRoute element={<LogsAnswers />} isPrivate />}
    />

    <Route
      path="/participation/:id/:code"
      element={<CustomRoute element={<Participation />} isSurvey />}
    />

    <Route
      path="/participationLink"
      element={<CustomRoute element={<ParticipationLink />} isPrivate />}
    />
    <Route
      path="/participationLink/new"
      element={<CustomRoute element={<CreateParticipationLink />} isPrivate />}
    />
    <Route
      path="/participationLink/edit/:id"
      element={<CustomRoute element={<EditParticipationLink />} isPrivate />}
    />

    <Route
      path="/analytics"
      element={<CustomRoute element={<AnalyticsPageLinks />} isPrivate />}
    />
    <Route
      path="/analyticsLink/new"
      element={<CustomRoute element={<AnalyticsPageNew />} isPrivate />}
    />
    <Route
      path="/analyticsLink/edit/:id"
      element={<CustomRoute element={<AnalyticsPageEdit />} isPrivate />}
    />

    <Route
      path="/exportDatawarehouse"
      element={<CustomRoute element={<SurveyListToExport />} isPrivate />}
    />

    <Route
      path="/resetPassword"
      element={<CustomRoute element={<ResetPassword />} isPrivate />}
    />

    <Route
      path="/recoverySummary"
      element={<CustomRoute element={<RecoverySummary />} isPrivate />}
    />
  </Routes>
);

export default RoutesComponent;
